<!-- <app-banners></app-banners> -->
<!-- <app-cards></app-cards> -->

<!--<app-promos></app-promos>-->
<app-banners-hp></app-banners-hp>
<app-cards></app-cards>
